import React from "react";

function CopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M15.8438 13.75H9.09375C7.85273 13.75 6.84375 12.741 6.84375 11.5V2.5C6.84375 1.25898 7.85273 0.25 9.09375 0.25H14.0191C14.4656 0.25 14.8945 0.429297 15.2109 0.745703L17.598 3.13281C17.9145 3.44922 18.0938 3.87812 18.0938 4.32461V11.5C18.0938 12.741 17.0848 13.75 15.8438 13.75ZM2.34375 4.75H5.71875V6.4375H2.34375C2.03437 6.4375 1.78125 6.69063 1.78125 7V16C1.78125 16.3094 2.03437 16.5625 2.34375 16.5625H9.09375C9.40312 16.5625 9.65625 16.3094 9.65625 16V14.875H11.3438V16C11.3438 17.241 10.3348 18.25 9.09375 18.25H2.34375C1.10273 18.25 0.09375 17.241 0.09375 16V7C0.09375 5.75898 1.10273 4.75 2.34375 4.75Z"
        fill="#277DFE"
      />
    </svg>
  );
}

export default CopyIcon;
